var map = {
	"./alpaca.webp": 1090,
	"./augusto.webp": 4063,
	"./backgroundImage.webp": 8717,
	"./carga/nube_1_1.webp": 7121,
	"./carga/nube_1_2.webp": 37,
	"./carga/nube_izquierda.webp": 7694,
	"./carga/nube_suave_adelante.webp": 9217,
	"./carga/nube_suave_adelante_2.webp": 5317,
	"./carga/nube_suave_atras.webp": 6745,
	"./carga/nuve_derecha.webp": 5975,
	"./charly.webp": 2119,
	"./denu.webp": 7372,
	"./neme.webp": 3301,
	"./perfil.webp": 1831,
	"./portafolio/ALA-B.webp": 8130,
	"./portafolio/APOYO-B.webp": 6048,
	"./portafolio/Crossfy-B.webp": 7454,
	"./portafolio/EMD-B.webp": 8246,
	"./portafolio/HP2-B.webp": 7100,
	"./portafolio/HxN-B.webp": 3695,
	"./portafolio/INDEMNIZAR-B.webp": 1904,
	"./portafolio/PRO-B.webp": 2455,
	"./portafolio/SMS-B.webp": 9989,
	"./portafolio/VALEN-B.webp": 3262,
	"./portafolio/YGG-B.webp": 4311,
	"./samir.webp": 4261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9766;